import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getTestDriveDetails = () => {
  const url = API_URLS.testDrive;
  return axiosClient.get(url);
};

export const getDealersDetails = (page) => {
  const url = API_URLS.dealersDetails(page);
  return axiosClient.get(url);
};
export const getIndustryCategory = () => {
  const url = API_URLS.homepage;
  return axiosClient.get(url);
};
export const postTestDriveInfo = (postStrapiData) => {
  const url = API_URLS.storeTestDriveInfo;
  return axiosClient.post(url, postStrapiData);
};
